import { Component } from '@angular/core';

import { AuthService } from '../auth/auth.service';

/**
 * This class represents the toolbar component.
 */
@Component({
  selector: 'app-toolbar',
  templateUrl: 'toolbar.component.html',
  styleUrls: ['toolbar.component.scss']
})
export class ToolbarComponent {
  constructor(public auth: AuthService) {
    //
  }
}




// WEBPACK FOOTER //
// /ng-app/src/app/shared/toolbar/toolbar.component.ts